export default "__VITE_ASSET__aa55fbe5__"